export default __webpack_public_path__ + "static/media/home-circle.8cc70e4a.svg";